import styled from 'styled-components'

export const Container = styled.div`
  .ant-collapse {
    margin-top: 10px;
  }

  #btn_DeleteAddress {
    color: #f04055;
  }

  #update_address {
    color: var(--primary-color);
  }
`

export const Grid = styled.div`
  display: flex;
  align-items: stretch;
  gap: 1rem;
`
